import React from 'react';
import { Outlet } from 'react-router-dom';
import { Stack, IStackStyles, MessageBar, MessageBarType, ITheme } from '@fluentui/react';

import Header from './Header';
import Sidebar from './Sidebar';
import MessageCourier from '../../../lib/MessageCourier';
import { MessageReceiver } from '../../../lib/MessageReceiver';
import SystemClient from '../../../system/SystemClient';
import ErrorTemplateDialog from '../ErrorTemplateDialog';
import { Alert, Snackbar } from '@mui/material';
import { Usuario } from '../../../system/Usuario/Usuario';
const mainStackStyles: Partial<IStackStyles> = {
  root: {
    width: '100%',
    margin: '0 auto',
    height: '95 vh',
  },
};

interface IBaseProps {
  courier: MessageCourier;
  system: SystemClient;
  changeBlockUI: (v: boolean) => void;
  user?: Usuario;
  changeTheme: () => void;
  theme: ITheme;
}

interface IBaseState {
  isSidebarOpen: boolean;
  abortController?: AbortController;
  message?: string;
  messageType?: MessageBarType;
  isDialogType?: boolean;
  openDialog?: boolean;
}

class Base extends React.Component<IBaseProps, IBaseState> implements MessageReceiver {
  constructor(props: IBaseProps) {
    super(props);
    this.state = { isSidebarOpen: false };
  }

  componentDidMount(): void {
    if (this.props.courier) {
      this.props.courier.subscribe(this);
    }
  }

  receiveError(message: string, _error: unknown): void {
    this.setState({ message, messageType: MessageBarType.error });
    setTimeout(() => {
      this.onDismissMessage();
    }, 30000);
  }

  receiveDialogError(message: string, _error: unknown): void {
    console.log('paso');
    this.setState({ message, messageType: MessageBarType.error, isDialogType: true, openDialog: true });
  }

  receiveSuccess(message: string): void {
    this.setState({ message, messageType: MessageBarType.success });
    setTimeout(() => {
      this.onDismissMessage();
    }, 30000);
  }

  private onDismissMessage = () => {
    this.setState({ message: undefined });
  };

  render() {
    const { isSidebarOpen, message, messageType, isDialogType, openDialog } = this.state;

    return (
      <React.Fragment>
        <div style={{ borderBottom: '1px solid' + this.props.theme.palette.neutralQuaternary }}>
          <Header
            system={this.props.system}
            onMenuButtonClick={() => this.openSibedar()}
            changeBlockUI={this.props.changeBlockUI}
            courier={this.props.courier}
            user={this.props.user}
          />
        </div>

        <Stack horizontal styles={mainStackStyles}>
          <Sidebar
            isOpen={isSidebarOpen}
            user={this.props.user}
            dismissPanel={() => this.closeSibedar()}
            changeTheme={this.props.changeTheme}
          />

          <section className="section-container">
            {/* {message && !isDialogType && (
              <MessageBar
                styles={{
                  content: { padding: 7 },
                  innerText: { fontSize: '14px !important' },
                  icon: { fontSize: '14px !important' },
                }}
                messageBarType={messageType}
                isMultiline={false}
                onDismiss={this.onDismissMessage}
                dismissButtonAriaLabel="Close"
              >
                {message}
              </MessageBar>
            )} */}

            <Snackbar
              open={!!(message && !isDialogType)}
              autoHideDuration={30000}
              onClose={this.onDismissMessage}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              style={{ borderRadius: 0, zIndex: 9999999 }}
            >
              <Alert
                onClose={this.onDismissMessage}
                severity={
                  messageType === MessageBarType.success ? 'success' : MessageBarType.error ? 'error' : 'info'
                }
                sx={{ width: '100%' }}
              >
                {message}
              </Alert>
            </Snackbar>

            <ErrorTemplateDialog
              showDialog={!!openDialog}
              toggleShowDialog={() => this.setState({ openDialog: !!!this.state.openDialog })}
              errorMsg={message ? String(message) : ''}
            ></ErrorTemplateDialog>
            <Outlet />
          </section>
        </Stack>
      </React.Fragment>
    );
  }

  private openSibedar() {
    this.setState({ isSidebarOpen: true });
  }

  private closeSibedar() {
    this.setState({ isSidebarOpen: false });
  }
}

export default Base;
